<template>
  <SdsNavigationItem
    type="back"
    @click="navigate()"
  />
  <hr
    class="w-full h-2 mt-2 mb-2 border-gray-100 dark:border-gray-700"
  >
  <div
    v-for="(item, i) in children"
    :key="item.key"
    class="flex flex-col justify-start w-full group"
  >
    <SdsNavigationItem
      :label="item.label"
      :href="item.href"
      :external="item.external"
    >
      <p class="text-gray-600 group-hover:text-red-600 dark:group-hover:text-red-300 w-fit inline-block my-auto text-base">
        <span
          :class="{
            'font-light': item.type !== 'landing-page'
          }"
        >{{ item.label }}</span>
        <span
          v-if="item.cta || item.type === 'landing-page' || item.external"
          class="w-fit my-auto h-full whitespace-nowrap"
        >
          {{ '\u00a0' /* This is a whitespace character, it will prevent the trailing icon from wrapping */ }}
          <svg
            v-if="item.external && item.type === 'landing-page'"
            class="relative inline-block w-5 h-full float-right text-red-600 dark:text-red-300 transition-all"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              class="transition-transform -rotate-45 translate-y-[7px] -translate-x-[0.5px] scale-y-90 scale-x-95"
              stroke-width="1"
              d="M18.7063 12.7086C19.0969 12.318 19.0969 11.6836 18.7063 11.293L13.7063 6.29297C13.3156 5.90234 12.6813 5.90234 12.2906 6.29297C11.9 6.68359 11.9 7.31797 12.2906 7.70859L15.5875 11.0023H6C5.44687 11.0023 5 11.4492 5 12.0023C5 12.5555 5.44687 13.0023 6 13.0023H15.5844L12.2937 16.2961C11.9031 16.6867 11.9031 17.3211 12.2937 17.7117C12.6844 18.1023 13.3188 18.1023 13.7094 17.7117L18.7094 12.7117L18.7063 12.7086Z"
              fill="currentColor"
            />
            <path
              d="M11 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V13"
              class="opacity-100 scale-90"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <svg
            v-if="(item.cta || item.type === 'landing-page') && !item.external"
            class="inline-block w-3.5 mb-1 h-4 transition-all text-red-600 dark:text-red-300"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h306.7L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
            />
          </svg>
          <svg
            v-if="item.external && (item.type === 'simple' || item.type === 'descriptive')"
            class="w-5 h-full mb-[1px] -ml-0.5 opacity-100 relative inline-block transition-all"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              class="transition-transform -rotate-45 translate-y-[7px] -translate-x-[0.5px] scale-y-90 scale-x-95"
              stroke-width="1"
              d="M18.7063 12.7086C19.0969 12.318 19.0969 11.6836 18.7063 11.293L13.7063 6.29297C13.3156 5.90234 12.6813 5.90234 12.2906 6.29297C11.9 6.68359 11.9 7.31797 12.2906 7.70859L15.5875 11.0023H6C5.44687 11.0023 5 11.4492 5 12.0023C5 12.5555 5.44687 13.0023 6 13.0023H15.5844L12.2937 16.2961C11.9031 16.6867 11.9031 17.3211 12.2937 17.7117C12.6844 18.1023 13.3188 18.1023 13.7094 17.7117L18.7094 12.7117L18.7063 12.7086Z"
              fill="currentColor"
            />
            <path
              d="M11 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V13"
              class="opacity-100 scale-90"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </p>
    </SdsNavigationItem>
    <hr
      v-if="(
        (parseInt(item.column) !== parseInt(children[(i+1)]?.column)) &&
        (i).toString() !== (children.length-1).toString()
      )"
      class="w-full h-2 mt-2 mb-2 border-gray-100 dark:border-gray-700"
    >
  </div>
</template>

<script setup lang="ts">
defineProps({
  children: {
    type: Object,
    default: null
  },
  navigate: {
    type: Function,
    default: () => {}
  }
})
</script>
